import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';

@Component({
  selector: 'comp-our-plans',
  templateUrl: 'our-plans.html',
})
export class OurPlansPage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }

  activateLicense(license) {
    //link a wordpress
    var final_path = this.globals.api_path + "suscription/" + this.globals.user_email + "/stripe/" + license + "/month";
    this.sendMsgSlack(license);
    //
    if (this.globals.so_mobile) {
      window.location.assign(final_path);
    } else {
      window.open(final_path, '_blank');
    }
  }

  async sendMsgSlack(license) {
    var title = "CLICK PAYMENT STRIPE SUSCRIPTION :three_button_mouse:";
    var section = {
      "type": "section",
      "text": {
        "type": "mrkdwn",
        "text": ":credit_card: " + license.toUpperCase() + " \n :knife_fork_plate: " + this.globals.restaurant.company + " \n :e-mail: " + this.globals.restaurant.email + " \n :round_pushpin: " + (this.globals.restaurant.address_country || '') + ""
      }
    };
    this.globals.sendSlack(title, section, '#pay-mct');
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/our-plans/our-plans.ts